<template>
  <div>
    <appResult></appResult>
  </div>
</template>

<script>
import PartnerMeterLimit from "../../components/paywall/partner/sections/PartnerMeterLimit";

export default {
  data() {
    return {};
  },
  components: {
    appResult: PartnerMeterLimit,
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/partner/MeterLimitPanel.vue